import { inject } from '@angular/core';
import { Router, CanActivateFn, CanActivateChildFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LoggerService } from '@victory-lib-ui/shared/utils';

/**
 * Auth Guard
 * Protects routes that require authentication
 */
const AUTH_REDIRECT_ROUTE = ['/auth/login'];

const resolveAuthGuard = (guardLabel: string): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  if (authService.isAuthenticated) {
    return true;
  }

  logger.warn(`${guardLabel}: Unauthenticated user redirected to login`);
  router.navigate(AUTH_REDIRECT_ROUTE);
  return false;
};

export const authGuard: CanActivateFn = () => resolveAuthGuard('AuthGuard');

export const authChildGuard: CanActivateChildFn = () =>
  resolveAuthGuard('AuthChildGuard');

/**
 * Guest Guard
 * Redirects authenticated users away from auth pages
 */
export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  if (!authService.isAuthenticated) {
    return true;
  }

  logger.debug('GuestGuard: Authenticated user redirected to dashboard');
  router.navigate(['/dashboard']);
  return false;
};
